import { Modal, Space, Typography, ModalProps } from 'antd';
import { type Dispatch, type FC, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import Close from 'assets/images/liHome/close.svg';

const { Text, Title } = Typography;

type UseStateAction = Dispatch<SetStateAction<boolean>>;
type ExtendedCancelButtonProps = ModalProps['cancelButtonProps'];

export interface ClaimDetailsModalProps {
  handleOk: () => void;
  visible: boolean;
  setVisibility: UseStateAction;
  modalLoading: boolean;
  title: string;
  description?: string;
  cancelButtonProps?: ExtendedCancelButtonProps;
}

const CoverModal: FC<ClaimDetailsModalProps> = ({
  handleOk,
  visible,
  setVisibility,
  modalLoading,
  title,
  description,
  cancelButtonProps,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      okText={t('life.MakeRequest.contact.yes')}
      cancelText={t('life.MakeRequest.contact.no')}
      cancelButtonProps={cancelButtonProps}
      open={visible}
      onOk={handleOk}
      confirmLoading={modalLoading}
      onCancel={() => setVisibility(false)}
      className="e-notice-modal"
      closeIcon={<img src={Close} />}
    >
      <Space align="start">
        <div>
          <Title level={5} style={{ fontSize: '26px', color: '#C21B17', fontWeight: 400 }}>
            {title}
          </Title>
          {description && <Text style={{ fontSize: '17px', color: '#20252B', fontWeight: 400 }}>{description}</Text>}
        </div>
      </Space>
    </Modal>
  );
};

export default CoverModal;
